import { DEFAULT_PLAYER_SCORES } from 'game/constants/Constants';

export class ScoreModel {
  constructor() {
    this._prevScoreData = { ...DEFAULT_PLAYER_SCORES };
    this._scoreData = { ...DEFAULT_PLAYER_SCORES };
  }

  getPrevScoreByType(type) {
    return this._prevScoreData[type];
  }

  getScoreByType(type) {
    return this._scoreData[type];
  }

  scoreHasReachedZero() {
    // check if any of the scores have reached zero
    for (const key in this._scoreData) {
      if (this._scoreData[key] <= 0) {
        return true;
      }
    }

    return false;
  }

  getZeroScores() {
    const zeroScores = [];

    for (const key in this._scoreData) {
      if (this._scoreData[key] <= 0) {
        zeroScores.push(key);
      }
    }

    return zeroScores;
  }

  getSucessScores() {
    const scores = [];

    for (const key in this._scoreData) {
      if (this._scoreData[key] >= 80) {
        scores.push(key);
      }
    }

    return scores;
  }

  resetScores() {
    for (const key in this._scoreData) {
      this._scoreData[key] = 50;
    }
  }

  // getter/setter
  get getScores() {
    return this._scoreData;
  }

  get getPrevScores() {
    return this._prevScoreData;
  }

  set setScores(data) {
    for (const key in data) {
      const { type, score } = data[key];

      const nextScore = this._scoreData[type] + score;

      this._prevScoreData[type] = this._scoreData[type];
      this._scoreData[type] = Math.min(Math.max(nextScore, 0), 100);
    }
  }

  // ----------------
  // shortcut methods
  // ----------------
  setScoreType({ type, score }) {
    this._scoreData[type] = score;
  }
}
